"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utmFromUrl = void 0;
var UTM_ALLOWLIST = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_url',
];
/**
 * Pass the current URL to get the UTM tags from it
 * It will read the following values: 'utm_source', 'utm_medium',
  'utm_campaign', 'utm_content', 'utm_term' & 'utm_url'.
 * @param url of the current page including query parameters
 * @returns UtmTags object with the UTM tags from the URL
 */
function utmFromUrl(url) {
    var urlObject = new URL(url);
    var utmTags = new URLSearchParams(urlObject.search);
    var result = {};
    UTM_ALLOWLIST.forEach(function (key) {
        if (utmTags.has(key)) {
            result[key] = utmTags.get(key);
        }
    });
    return result;
}
exports.utmFromUrl = utmFromUrl;
//# sourceMappingURL=utm-from-url.js.map